import API from 'services/API';

export const get = flightId => API.get(`/delay/findByFlight?flightId=${flightId}`);

export const add = delay => API.post('/delay', delay);

export const del = id => API.delete(`/delay/${id}`);
